import initialState from '../../initialstate';
import * as types from '../../../actions/actiontypes';
import Utility from '../../../util/utilityfunctions';
import {normalize, normalizedDelete, normalizedUpdate} from '../../../util/utils';
import {validationTypes, documentTypes, AssignmentStatuses, TaskStatusIds, OpenInCanvasDocumentTypeIDs} from '../../../util/uiconstants';
import {getValidationCountForIds} from '../../../components/Common/CanvasForm/Common/ValidationUtility';

export function aresTaskListReducer(state = initialState.aresTaskList, action) {
	let newState;

	switch (action.type) {
		case types.GET_ALL_TASKS_BY_GROUP_ID: {
			if (action.response.taskGroups && action.response.taskGroups[0] && action.response.taskGroups[0].tasks.length > 0) {
				newState = applyResponse(action.response.taskGroups[0], state, action.isAresV2);
			}

			return newState || state;
		}

		case types.GET_ALL_DOCUMENTS: {
			if (action.error) {
				return state;
			}

			if (action.isHandOffEvidence) {
				const byId = {
					...state.byId
				};

				byId[action.taskId] = {
					...state.byId[action.taskId],
					evidenceDocumentIds: [...action.response.data.map((doc) => doc.id)]
				};

				return {
					...state,
					byId
				};
			} else if (action.response && action.response.data && action.response.data.length) {
				let tasksPayload = [];
				newState = {...state};

				// A task may be related to multiple documents, so we need to update the task object for each document
				// Add a collection of fitDocuments to the task object
				for (const document of action.response.data) {
					if (Array.isArray(document.tasks)) {
						for (const task of document.tasks) {
							// We only update tasks that are already present in the store
							const storeTask = newState.byId[task.id];
							if (storeTask) {
								// First we check if the task is in the tasksPayload array, if not, we initialize documentTask with the storeTask
								// (this is to cover the case in which a task is related to several documents)
								let documentTask = tasksPayload.find((t) => t.id === task.id);
								documentTask = documentTask || {...storeTask};

								// We build a task object just with the properties we need to update in the normalized state
								documentTask = {
									...documentTask,
									...task,
									documentId: document.id,
									documentTypeId: document.documentTypeId
								};

								documentTask.documents = documentTask.documents || [];

								if (!documentTask.documents.includes(document.id)) {
									documentTask.documents = documentTask.documents.concat(document.id);
								}

								// If the current document is a FIT form, add it to fitDocuments collection
								documentTask.fitDocuments = documentTask.fitDocuments || [];

								if (Utility.isDocumentTypeFit(document.documentTypeId) && !documentTask.fitDocuments.includes(document.id)) {
									documentTask.fitDocuments = documentTask.fitDocuments.concat(document.id);
								}

								tasksPayload.push(documentTask);
							}
						}
					}
				}

				newState = normalize(tasksPayload, undefined, newState);

				return {
					...newState,
					isDocumentInfoAvailable: true
				};
			}

			return state;
		}

		case types.GET_ALL_TASKS_OVERVIEW: {
			if (action.error) {
				return state;
			}

			const tasks = action.response?.tasks;
			const documents = action.response?.documents?.filter((doc) => OpenInCanvasDocumentTypeIDs.includes(doc?.documentTypeId));
			const taskAssignments = action.response?.assignments;
			if (tasks.length > 0 && documents) {
				newState = {...state};
				let tasksPayload = [];

				for (let task of tasks) {
					const taskDocuments = documents.filter((doc) => doc.taskId === task.id);

					task.documents = taskDocuments?.map((doc) => doc.id);
					task.fitDocuments = taskDocuments.filter((doc) => Utility.isDocumentTypeFit(doc.documentTypeId)).map((doc) => doc.id);

					if (taskAssignments) {
						let assignments = newState.byId[task.id]?.assignments ? newState.byId[task.id].assignments : [];
						taskAssignments.map((assignment) => {
							if (task.id === assignment.taskId && !assignments.find((a) => a.taskAssignmentId === assignment.taskAssignmentId))
								assignments.push({
									...assignment,
									isCurrent: assignment.assignmentStatusId === AssignmentStatuses.InProcess
								});
						});
						task.assignments = assignments;
					}

					task.taskStatusId = task.statusId ?? task.taskStatusId;

					tasksPayload.push(task);
				}

				// TaskIds in the store that do not exist in the taskOverview response tasks
				let tasksToDelete = newState.allIds.filter((taskId) => !tasks.find((task) => task.id === taskId));

				// Remove these tasks from the store
				if (tasksToDelete?.length > 0) {
					for (const taskId of tasksToDelete) {
						newState = normalizedDelete(newState, taskId);
					}
				}

				newState = normalize(tasksPayload, undefined, newState, undefined);

				//When we enter an activity, we do both task get by Id (to get the task whole data) and task overview call (to populate the left nav).
				//Task get by id puts the task id on the allIds array first.
				//Task overview then adds the remaining tasks ids on the allIds array.
				//This screws up the ordering we do on the SP, thats why we need to replace the array with the one that comes from task overview to not
				//loose the ordering.
				newState.allIds = action.response.tasks.map((t) => t.id);

				return newState;
			}

			return state;
		}

		case types.ARES_GET_DOCUMENT_BY_ID: {
			if (!action.error) {
				const responseDocument = action.response;

				// FIT -> Get the first system associated task from the document, or the first task.
				// Kronos -> Get all tasks related to the document.
				let documentTasks = responseDocument.tasks?.filter((task) => !action.isAresView || task.isSystemAssociated) || [];
				if (documentTasks.length === 0) {
					documentTasks = [responseDocument.tasks?.[0]] || [];
				}

				let payLoadTasks = [];
				for (const relatedTask of documentTasks) {
					const fitTask = {
						...relatedTask,
						documentId: responseDocument.id,
						documentTypeId: responseDocument.documentTypeId
					};

					if (fitTask) {
						const storeTask = state.byId[fitTask.id];
						fitTask.documents = storeTask?.documents || [];

						if (!fitTask.documents.includes(responseDocument.id)) {
							fitTask.documents = fitTask.documents.concat(responseDocument.id);
						}

						if (Utility.isDocumentTypeFit(responseDocument.documentTypeId)) {
							fitTask.fitDocuments = storeTask?.fitDocuments || [];

							if (!fitTask.fitDocuments.includes(responseDocument.id)) {
								fitTask.fitDocuments = fitTask.fitDocuments.concat(responseDocument.id);
							}
						}

						payLoadTasks.push(fitTask);
					}
				}

				if (payLoadTasks.length > 0) {
					return normalize(payLoadTasks, undefined, state);
				} else {
					return state;
				}
			}

			return state;
		}

		case types.GET_VALIDATIONCOUNTS: {
			if (action.error) {
				return state;
			}
			if (action.response && action.documentIds?.length > 0) {
				for (let taskId of state.allIds) {
					let currentTask = state.byId[taskId];

					// If the current task contains any action documentId in fitDocuments, we update the task object with the validation counts
					if (currentTask.fitDocuments?.length > 0 && currentTask.fitDocuments.some((docId) => action.documentIds.includes(docId))) {
						newState = !newState ? {...state} : newState;

						// Update the validationCounts on the task object
						newState = normalizedUpdate(taskId, applyValidationsByTaskId(action.response, currentTask.fitDocuments), newState);
					}
				}

				return newState || state;
			}

			return state;
		}

		case types.GET_TASK_ASSIGNMENTS: {
			if (action.error) {
				return state;
			}

			const taskAssignments = state.byId[action.taskId]?.assignments || [];
			const taskStatusId = state.byId[action.taskId]?.statusId;

			//TODO (discuss with Shane after release 2.11.0): We shouldn't have an if statement to manage assignments from different sources. We need to centralize it.
			//The first if statement handles the assignments which come from the task get all api call.
			//The second if statement handles the assignments which come from the task get assignments call (we don't do a get all task api call, we do the get all task overview which doesn't bring assignments today).
			//I believe we should just stick with the get all assignments call and not get them from different api calls using flags to include them. We should stick with the one at resource level.
			//We can't keep on having different data treatment depending on which api call you are coming from, it's hard to maintain and not scalable.
			const assignments =
				taskAssignments.length > 0
					? taskAssignments.map((assignment) => {
							const _assignment = action?.response?.reviewersList.find(
								(a) =>
									(a.assignmentId === assignment.assignmentId || a.assignmentId === assignment.id) &&
									a.taskAssignmentId === assignment.taskAssignmentId &&
									(a.assignedToUserId === assignment.assignedToUserId || a.assignedToRoleId === assignment.assignedToRoleId)
							);

							return {
								...assignment,
								assignmentStatusId: applyAssignmentStatusId(_assignment, taskStatusId),
								modifiedByFirstName: _assignment.modifiedByFirstName,
								modifiedByLastName: _assignment.modifiedByLastName,
								modifyDate: _assignment.modifiedByDate,
								isCurrent: _assignment.isCurrent
							};
						})
					: action?.response?.reviewersList.map((assignment) => {
							return {
								...assignment,
								assignmentStatusId: applyAssignmentStatusId(assignment, taskStatusId),
								taskTimePhase: action?.response.taskTimePhase
							};
						});

			return normalizedUpdate(action.taskId, {assignments}, state);
		}
		case types.ARES_GET_TASK_BY_ID: {
			if (!action.error) {
				if (action && action.taskId && action.response) {
					return normalizedUpdate(
						action.taskId,
						{
							...action.response,
							statusId: action.response.taskStatusId,
							timePhaseId: action.response.timephase?.id,
							isTaskById: true
						},
						state
					);
				} else {
					return state;
				}
			}
			return state;
		}

		case types.HANDOFF_TASK: {
			if (action.error) {
				return state;
			}

			const byId = {
				...state.byId
			};

			byId[action.taskId] = {
				...state.byId[action.taskId],
				currentAssignedRoleId: action.currentAssignedRoleId,
				currentAssignedToUserId: action.currentAssignedToUserId,
				currentAssignedToEmailAddress: action.currentAssignedToEmailAddress,
				currentAssignedToUserInitials: action.currentAssignedToUserInitials
			};

			return {
				...state,
				byId
			};
		}

		default:
			return state;
	}
}

//Groups all document validations by taskId and returns a redux store object with a new task id entry holding the sum of all validations.
function applyValidationsByTaskId(validations, taskRelatedDocumentIds = []) {
	let taskRelatedValidations = [];
	let incompleteResponseCount = 0,
		unresolvedCommentsCount = 0;

	//If we have related docs we start doing the validation calculations.
	if (taskRelatedDocumentIds.length > 0) {
		//We filter the validations of the specific related documents to the task.
		taskRelatedValidations = validations.filter((v) => taskRelatedDocumentIds.indexOf(v.documentId) !== -1);

		//We get all the validation counts across all documents of a certain type and sum them all.
		incompleteResponseCount = taskRelatedValidations
			.filter((v) => v.validationTypeId === validationTypes.FinalizeIncompleteCanvasFromResponses)
			.map((v) => v.validationCount)
			.reduce((a, b) => a + b, 0);

		unresolvedCommentsCount = taskRelatedValidations
			.filter((v) => v.validationTypeId === validationTypes.CanvasFromComments)
			.map((v) => v.validationCount)
			.reduce((a, b) => a + b, 0);
	}

	return {
		validationCounts: {
			incompleteResponseCount: incompleteResponseCount,
			unresolvedCommentsCount: unresolvedCommentsCount,
			guidedWorkFlowValidations:
				getValidationCountForIds(
					undefined,
					undefined,
					undefined,
					taskRelatedValidations.filter(
						(v) => v.validationTypeId !== validationTypes.CanvasFromComments && v.validationTypeId !== validationTypes.FinalizeIncompleteCanvasFromResponses
					),
					undefined,
					documentTypes.guidedWorkflow,
					true
				)?.guidedWorkFlowValidations || []
		}
	};
}

function applyResponse(taskGroup, state, isAresV2) {
	let taskList = [];
	let tasks = taskGroup.tasks;

	for (let i = 0; i < tasks.length; i++) {
		let responseTask = tasks[i];
		let task = {
			id: responseTask.id,
			knowledgeTaskTitle: responseTask.knowledgeTaskTitle,
			knowledgeTaskShortName: responseTask.knowledgeTaskShortName,
			currentAssignedToFirstName: responseTask.currentAssignedToFirstName,
			currentAssignedToLastName: responseTask.currentAssignedToLastName,
			imageName: responseTask.imageName,
			name: responseTask.name,
			taskNamePrefix: responseTask.taskNamePrefix,
			taskNameSuffix: responseTask.taskNameSuffix,
			taskDisplayName: responseTask.taskDisplayName,
			statusId: responseTask.statusId,
			currentAssignedRoleId: responseTask.currentAssignedRoleId,
			currentAssignedToUserId: responseTask.currentAssignedToUserId,
			currentAssignedToEmailAddress: responseTask.currentAssignedToEmailAddress,
			currentAssignedToUserInitials: responseTask.currentAssignedToUserInitials,
			assignments: responseTask.assignments.map((assignment) => {
				return {...assignment, assignedToUserId: assignment.assignedtoUserId};
			}),
			typeId: responseTask.typeId,
			timePhaseId: responseTask.timephaseId
		};

		taskList.push(task);
	}

	let newState;
	if (isAresV2) {
		newState = {...state};
		for (const task of taskList) {
			newState = normalizedUpdate(task.id, task, newState);
		}
	} else {
		newState = normalize(taskList, undefined, state);
		newState.allIds = taskList.map((task) => task.id);
	}

	return newState;
}

function applyAssignmentStatusId(assignment, taskStatusId) {
	let status = AssignmentStatuses.Open;

	if (assignment) {
		if (assignment.isComplete) {
			status = AssignmentStatuses.Complete;
		} else if (taskStatusId && taskStatusId === TaskStatusIds.Open) {
			status = AssignmentStatuses.Open;
		} else if (assignment.isCurrent) {
			status = AssignmentStatuses.InProcess;
		}
	}

	return status;
}
